import { RouteObject } from "react-router-dom";

import { NotFound } from "@/features/error";
import { AuthRoutes } from "@/features/auth";

export const publicRoutes: RouteObject[] = [
  ...AuthRoutes,
  {
    path: "/error/404",
    element: <NotFound />,
  },
];
